import ENDPOINTS from "./Endpoints";
import { nutClientForRole } from "./nutClient";
import { NutritionWeeklyType } from "../../modules/platform/components/programming/nutritionPlan/model/nutritionPlanTypes";

/**
 * Nutrition plan endpoints on the NUT service. Kept out of `Api.ts` because
 * the plan feature grows over several phases (logging, swapping, groceries)
 * and each adds a handful of calls. The role → client switch is shared with
 * the workout plan in `nutClient.ts`.
 */
const planParams = (date: string) => ({ params: { date, original: false } });

/** The Monday-based week containing `date`. Pass the Monday itself, as the mobile app does. */
export const getActiveWeeklyPlan = async (
  date: string,
  role: number
): Promise<NutritionWeeklyType | null> => {
  const client = await nutClientForRole(role);
  if (!client) return null;
  const response = await client.get<NutritionWeeklyType>(
    ENDPOINTS.NUTRITION.CUSTOMER_ACTIVE_PLAN_WEEKLY,
    planParams(date)
  );
  return response.data;
};
